import { render, staticRenderFns } from "./ViewMatchingJob.vue?vue&type=template&id=56311682&scoped=true&"
import script from "./ViewMatchingJob.vue?vue&type=script&lang=ts&"
export * from "./ViewMatchingJob.vue?vue&type=script&lang=ts&"
import style0 from "./ViewMatchingJob.vue?vue&type=style&index=0&id=56311682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56311682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSkeletonLoader})
